export default {
    OFFSET: 48,
};
